var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "12px",
    viewBox: "0 0 11 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Control/open") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-store",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Pre-submission]-Configure_certifications-EPOS",
    transform: "translate(-542.000000, -326.000000)",
    fill: "#029DD0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Control/open",
    transform: "translate(539.500000, 324.198325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1680822,2.66666667 C6.48320688,2.66666667 6.51469488,2.89355644 6.51784124,2.93893439 L6.5178706,3.72688614 C6.51506949,3.77730609 6.48985951,4.00699697 6.26296974,4.05741692 L6.1680822,4.0672208 L4.0672208,4.0672208 L4.0672208,11.9327792 L11.9327792,11.9327792 L11.9327792,9.8319178 C11.9327792,9.51679312 12.2163914,9.48528065 12.2731139,9.4821294 L13.0532225,9.48180947 C13.0532225,9.48180947 13.3333333,9.48177927 13.3333333,9.8319178 L13.3333333,12.6330563 C13.3333333,13.0532225 13.0532225,13.3333333 12.6330563,13.3333333 L3.36694373,13.3333333 C2.98179135,13.3333333 2.71432441,13.0979624 2.67242126,12.735099 L2.66666667,12.6330563 L2.66666667,3.36694373 C2.66666667,2.98179135 2.90203757,2.71432441 3.26490104,2.67242126 L3.36694373,2.66666667 L6.1680822,2.66666667 Z M8.60061218,2.62157781 L13.0110864,2.73343147 C13.2066861,2.73042402 13.3562514,2.87485758 13.3600721,3.0704431 L13.3786408,7.35019018 C13.3824615,7.5457757 13.2386273,7.69472042 13.0430276,7.69772786 L12.3584286,7.70825392 C12.1628289,7.71126136 12.0132635,7.56682781 12.0094428,7.37124229 L11.9735663,5.01527022 L8.13798641,8.98712945 C7.99415217,9.13607417 7.79855245,9.13908162 7.59913202,8.94650354 L7.10058094,8.46505836 C6.95101562,8.32062481 6.9471949,8.12503929 7.09102914,7.97609457 L10.926609,4.00423534 L8.62735721,3.99067643 C8.4317575,3.99368387 8.28219217,3.84925032 8.27837145,3.6536648 L8.26499894,2.96911549 C8.26117822,2.77352997 8.40501246,2.62458525 8.60061218,2.62157781 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Open-Link.44eedaa233a5b95a12e9b5d730d4c1df.svg";